import './ServicesBlock.css';
import React from "react";
export var ServicesBlock = function ServicesBlock(_ref) {
  var service = _ref.service,
    hostLink = _ref.hostLink,
    rtl = _ref.rtl;
  var title = service.title,
    tags = service.tags,
    url = service.url,
    introText = service.introText;
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    className: "serviceItem"
  }, tags && tags.length ? /*#__PURE__*/React.createElement("div", {
    className: "serviceItem__tags"
  }, tags.map(function (tag, index) {
    return index ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", null, ' · '), /*#__PURE__*/React.createElement("span", null, tag)) : /*#__PURE__*/React.createElement("span", null, tag);
  })) : null, /*#__PURE__*/React.createElement("h4", {
    className: "serviceItem__title body-medium"
  }, /*#__PURE__*/React.createElement("a", {
    href: url,
    title: title,
    "aria-label": "Title",
    "aria-labelledby": "Title"
  }, title)), /*#__PURE__*/React.createElement("p", {
    className: "serviceItem__description body-small"
  }, introText)));
};
var StyledWrapper = function StyledWrapper(_ref2) {
  var children = _ref2.children,
    rtl = _ref2.rtl;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(commonStyles)
  }, children);
};
export var commonStyles = "c1u54o3c";